/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import React, { useEffect } from "react";
import { Children, cloneElement, isValidElement, useState } from "react";
import { Tooltip, IconButton, Menu, Button } from "@material-ui/core";
import UserIcon from "../assets/UserMenu/user.svg";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { useDataProvider } from "ra-core";
import { userUpdatedAction } from "../reducers/userProfileReducer";

const useStyles = makeStyles(
  (theme) => ({
    user: {},
    userButton: {
      textTransform: "none",
    },
    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  }),
  { name: "RaUserMenu" }
);

const AnchorOrigin = {
  vertical: "bottom",
  horizontal: "right",
};

const TransformOrigin = {
  vertical: "top",
  horizontal: "right",
};

export function UserMenu(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles(props);
  const dataProvider = useDataProvider();
  const userProfile = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  useEffect(() => {
    async function update() {
      const response = await dataProvider
        .getOne(`users/profile`, { id: "me" })
        .catch(() => {
          return null;
        });
      if (response) {
        dispatch(userUpdatedAction(response.data));
      }
    }
    update();
  }, [dataProvider, dispatch]);

  const icon = <img src={UserIcon} alt="Account Circle" width={25} />;
  const { children, label, logout } = props;
  if (!logout && !children) return null;
  const open = Boolean(anchorEl);

  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <div className={classes.user}>
      {userProfile?.fullName ? (
        <Button
          aria-label={label}
          className={classes.userButton}
          color="inherit"
          startIcon={icon}
          onClick={handleMenu}
        >
          {userProfile?.fullName}
        </Button>
      ) : (
        <Tooltip title={label}>
          <IconButton
            aria-label={label}
            aria-owns={open ? "menu-appbar" : null}
            aria-haspopup={true}
            color="inherit"
            onClick={handleMenu}
          >
            {icon}
          </IconButton>
        </Tooltip>
      )}
      <Menu
        id="menu-appbar"
        disableScrollLock
        anchorEl={anchorEl}
        anchorOrigin={AnchorOrigin}
        transformOrigin={TransformOrigin}
        // Make sure the menu is display under the button and not over the appbar
        // See https://material-ui.com/components/menus/#customized-menus
        getContentAnchorEl={null}
        open={open}
        onClose={handleClose}
      >
        {Children.map(children, (menuItem) =>
          isValidElement(menuItem)
            ? cloneElement(menuItem, {
                onClick: handleClose,
              })
            : null
        )}
        {logout}
      </Menu>
    </div>
  );
}
